import { useContext } from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import { PageContext, PageType } from "../../../App";
import PageContextType from "../../../types/PageContextType";

type BackgroundSectionPropsType = {
    title : string;
    subtitle : string;
    image : {
        src : string,
        alt : string,
    },
    button : {
        text : string,
        path : PageType,
        buttonTitle? : string;
    }
}

const BackgroundSection = ({
    title,
    subtitle,
    image,
    button
} : BackgroundSectionPropsType) => {
    const { handleChangePage } = useContext<PageContextType>(PageContext);

  return (
    <div className="section-bg">
        <ReactVisibilitySensor
            partialVisibility
        >
        {({isVisible} : any) => (
            <img 
                src={image.src} 
                className={`an-scale-up ${isVisible ? "an-active" : ""}`}
                alt={image.alt}
            />
        )}
        </ReactVisibilitySensor>
        <div className="content">
            <div className="wrapper-small">
                <div className='content-box'>
                    <ReactVisibilitySensor
                        partialVisibility
                    >
                    {({isVisible} : any) => (
                        <h2 className={`title an-move-top-fade-in ${isVisible ? "an-active" : ""}`}>{title}</h2>
                    )}
                    </ReactVisibilitySensor>
                    <ReactVisibilitySensor
                        partialVisibility
                    >
                    {({isVisible} : any) => (
                        <p className={`subtitle an-move-top-fade-in ${isVisible ? "an-active" : ""}`}>{subtitle}</p>
                    )}
                    </ReactVisibilitySensor>
                    <ReactVisibilitySensor
                        partialVisibility
                    >
                    {({isVisible} : any) => (
                        <button 
                            type="button"
                            className={`button-link an-move-top-fade-in ${isVisible ? "an-active" : ""}`}
                            title={button.buttonTitle || ""}
                            onClick={() => handleChangePage(button.path)}
                        >
                            {button.text}
                        </button>
                    )}
                    </ReactVisibilitySensor>
                </div>
            </div>
        </div>
    </div>
  )
}

export default BackgroundSection